import Splide from '@splidejs/splide';

function waitForPluginLoading(selector) {
  return new Promise((resolve, reject) => {
    try {
      const waitPluginLoading = window.setInterval(() => {
        if (document.querySelector(selector)) {
          resolve(true);
          window.clearInterval(waitPluginLoading);
        }
      }, 50);
    } catch (e) {
      reject(e);
    }
  });
}

async function initCarousel() {
  const imagesCarousel = new Splide('.work-with-us-carousel-splide', {
    type: 'loop',
    autoplay: true,
    rewind: true,
    perPage: 1,
    arrows: false,
    drag: false,
    interval: 2000
  });

  imagesCarousel.on('pagination:mounted', function (data) {
    data.list.classList.add('custom-splide-track');

    data.items.forEach(function (item) {
      item.button.classList.add('custom-splide-dot');
    });
  });

  imagesCarousel.mount();
}

function setupJobList(isPluginLoaded) {
  // TODO: Commented lines are momentary, expected to replace some of the current script parts in the future
  if (isPluginLoaded) {
    const jobSelect = document.querySelector('.aw_select[name=FlgAdsFilterJob]');
    const locationSelect = document.querySelector('.aw_select[name=FlgAdsFilterPlace]');
    // const searchButton = document.querySelector('.aw_searchButton');
    // const searchBox = document.querySelector('.aw_searchBox');

    // jobSelect.style.display = 'none';
    jobSelect.options[0].label = $('.utility-parameters').data('job-select-label');
    // positionSelect.style.width = `calc(100%
    //   - ${Math.min(39, searchButton.offsetWidth)}px
    //   - ${Math.max(5, parseInt(window.getComputedStyle(searchBox).paddingRight))}px)`;
    locationSelect.options[0].label = $('.utility-parameters').data('location-select-label');
  }
}

async function setupPlugin() {
  await waitForPluginLoading('.aw_jobList').then((plugin) => setupJobList(plugin));
}

// TODO: Commented for the moment, but expected to be added in the future
// function clickPluginSection() {
//   $('body').on('click', '.plugin-button', function (e) {
//     e.preventDefault();
//     const pressedButton = $(this);
//     const searchButton = document.querySelector('.aw_searchButton button');
//     const relatedDropdown = document.querySelector(`.aw_select[name=FlgAdsFilter${pressedButton.attr('id')}`);

//     document.querySelectorAll('.plugin-button').forEach(function (button) {
//       button.classList.remove('active');
//     });
//     document.querySelectorAll('.aw_select').forEach(function (dropdown) {
//       dropdown.selectedIndex = 0;
//     });
//     pressedButton.addClass('active');
//     relatedDropdown.value = pressedButton.data('param');
//     searchButton.click();
//   });
// }

document.addEventListener('DOMContentLoaded', () => {
  // Setup
  initCarousel();
  setupPlugin();

  // Listeners
  // TODO: Commented for the moment, but expected to be added in the future
  // clickPluginSection();
});
